import { render, staticRenderFns } from "./LikeButtons.vue?vue&type=template&id=557836af&scoped=true&"
import script from "./LikeButtons.vue?vue&type=script&lang=js&"
export * from "./LikeButtons.vue?vue&type=script&lang=js&"
import style0 from "./LikeButtons.vue?vue&type=style&index=0&id=557836af&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557836af",
  null
  
)

export default component.exports